module.exports = __webpack_public_path__ + "img/avatar_3.5681b73b.png";